<div class="modal-container p-6">
  <div class="modal-top">
    <h1 mat-dialog-title>Uppge felaktig information</h1>
    <div class="close-btn">
      <app-ui-icon (click)="closeDialog()" color="var(--blue-3)" name="close" size="md"></app-ui-icon>
    </div>
  </div>

  <div mat-dialog-content>
    <p>
      Förklara i formuläret nedan vilken information som inte stämmer så att
      innehållsansvarig får information om vad som behöver rättas till.
    </p>
    <form [formGroup]="askForm">
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="full-width">
            <textarea
              formControlName="message"
              matInput
              placeholder="Vad är felet?"
            ></textarea>
            <mat-error *ngIf="askForm.controls.message.hasError('required')">
              Vänligen fyll i detta fält
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="full-width">
            <input
              formControlName="email"
              matInput
              placeholder="E-postadress (frivillig)"
            >
            <mat-error
              *ngIf="
                askForm.controls.email.hasError('email') &&
                !askForm.controls.email.hasError('required')
              "
            >
              Ange en giltig e-postadress
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-actions" mat-dialog-actions>
    <app-ui-button
      (onClick)="saveRequest()"
      [color]="'secondary'"
      [compressed]="false"
      [expanded]="'inline'"
      [size]="'lg'"
    >
      Skicka
    </app-ui-button>

    <app-ui-button
      (onClick)="closeDialog()"
      [color]="'ghost'"
      [compressed]="false"
      [expanded]="'inline'"
      [size]="'lg'"
    >
      Stäng
    </app-ui-button>
  </div>
</div>
